<template>
  <section class="pd-y-30" style="background: #f7faff">
    <div class="container" style="max-width: 600px !important">
      <div class="section-title">
        <h2>{{ comp.task }}</h2>
        <p>{{ comp.f1 }}</p>
      </div>
    </div>
    <div class="container">
      <!-- <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4" v-for="(t,i) in tasks" :key="i">
            <div class="card">
              <router-link :to="({name: $store.state.app.activeGroup.publicPage.route, params:{
                id: $store.state.app.contentPageId, cid: t.id
              }})">
                <img    :src="`${t.defaultAttachmentUrl}?w=460&h=360&mode=crop`" class="card-img wd-100p" />
                <div class="card-body">
                  <h5 class="card-title text-truncate">{{t.task}}</h5>
                  <div class="text-orange">{{t.createdDate | moment('YYYY.MM.DD')}}</div>
                </div>
              </router-link>
            </div>
          </div>
        </div> -->
      <div>
        <div no-body class="mb-1 card " v-for="(t, i) in tasks" :key="i">
          <!-- <b-card-header header-tag="header" class="p-1 card-header" role="tab">
            
          </b-card-header> -->
          <div
            role="button"
            @click="acteiveIndex = t.id"
            class="card-header pd-t-20 pd-b-15 d-md-flex align-items-center justify-content-between"
          >
            <h6 class="mg-b-0">{{ t.task }}</h6>
          </div>
          <div v-show="acteiveIndex == t.id">
            <div class="card-body">
              <div v-html="t.taskDesc"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: [],
      acteiveIndex: null
    };
  },
  mounted() {
    this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    loadTasks(typeId) {
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 5,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    }
  }
};
</script>

<style></style>
